import * as React from 'react';
import styled from "styled-components";
import {Title, SectionTitle} from "../../styled";
import Card, {Container as CardContainer} from "./componetns/Card";

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const Description = styled.div`
  max-width: 360px;
  margin-top: 30px;
  color: #4F4F51;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.01em;
`

const Cards = styled.div`
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, 359px);
  gap: 40px;
  align-items: start;
  
  @media screen and (max-width: 1117px) {
    display: flex;
    flex-direction: column;

    ${CardContainer} {
      max-width: 680px;
    }
  }
`;

const Container = styled.div`
  margin-left: 90px;
  width: 100%;
  max-width: 1160px;

  @media screen and (max-width: 1270px) {
    margin: 0;
    
    ${Description} {
      margin-top: 10px;
    }
    
    ${Cards} {
      margin-top: 12px;
      gap: 10px;
    }
  }
`;

/**
 * render landing page platform features section
 * @constructor
 */
export default function Features(): React.ReactElement {
  return (
    <Container>
      <SectionTitle>особенности платформы</SectionTitle>
      <Header>
        <Title>
          Создано специально для
          <span> онлайн школ</span>
        </Title>
        <Description>
          При разработке платорфмы
          учитывался опыт и потребности
          владельцев онлайн школ,
          с суммарным годовым оборотом
          <br/>
          в 1 млрд рублей
        </Description>
      </Header>
      <Cards>
        <Card
          value={'3x'}
          title={'В 3 раза ускоряет создание и продажи онлайн курсов '}
          description={'в 10 раз при использовании обычных CMS '}
        />
        <Card
          value={'50%'}
          title={'В среднем выше конверсия в покупку'}
          description={'Промо, upsale, cross-sell, OTO и другие инструменты 2 в клика'}
        />
        <Card
          value={'99%'}
          title={'Самая высокая конверсия в доставку'}
          description={'Веб-приложение, на акутальных технолгиях, одинаково великолепно работает на любом устройстве'}
        />
      </Cards>
    </Container>
  );
}
